import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ModalController, PopoverController } from 'ionic-angular'; 
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app/app-config';
import { UserserviceProvider } from '../../providers/userservice';
import { GriffeTypPage } from '../griffetyp/griffetyp'; 
import { VerglasungPage } from '../verglasung/verglasung'; 
import { QuickviewPage } from '../quickview/quickview';

@Component({
  selector: 'page-griffe',
  templateUrl: 'griffe.html',
})
export class GriffePage {
productname: string;
producttype: string;
windowtype: string;
typeopen: string
windowlong: string;
windowwide: string;
dichtungen: string;
dekorfarbe: string;
outColorIn: any;
outColorOut: any;
selectedGriffe: any;
choosenGriffe: any;
griffe_subcat: any;
griffe: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public http: HttpClient, public appConfig: AppConfig, public userService: UserserviceProvider, public loadingCtrl: LoadingController, public modalCtrl: ModalController, public popoverCtrl: PopoverController) {
  
    this.selectedGriffe = -1;

    this.dichtungen = this.navParams.get('dichtungen');
    this.outColorIn = this.navParams.get('outColorIn');
    this.outColorOut = this.navParams.get('outColorOut');
    this.typeopen = this.navParams.get('typeopen');
    this.windowtype = this.navParams.get('windowtype');
    this.productname = this.navParams.get('productname');
    this.producttype = this.navParams.get('producttype');
    this.windowlong = this.navParams.get('windowlong');
    this.windowwide = this.navParams.get('windowwide');
    console.log( this.productname, this.producttype, this.windowtype, this.typeopen, this.windowlong, this.windowwide, this.dichtungen, this.outColorIn, this.outColorOut); 
  
  } 
  
      presentQuickView() {
    this.myChoice = {productname: this.productname, producttype :this.producttype, windowtype:this.windowtype, typeopen:this.typeopen, windowlong: this.windowlong, windowwide: this.windowwide, outColorIn:this.outColorIn, outColorOut:this.outColorOut, dichtungen: this.dichtungen }
    const popover = this.popoverCtrl.create(QuickviewPage, this.myChoice, {cssClass: 'popover-top-right'});
    popover.present();
  } 
 
  ionViewDidLoad() {
    console.log('ionViewDidLoad GriffePage');
  } 
  
    ionViewWillEnter() : void
   {
   }
   
    clickgriffe(selectedGriffe) {
    this.navCtrl.push(VerglasungPage, {
    selectedGriffe: selectedGriffe,
    dichtungen: this.dichtungen,
    outColorIn: this.outColorIn,
    outColorOut: this.outColorOut,
    typeopen: this.typeopen,
    windowtype: this.windowtype,
    productname: this.productname,
    producttype: this.producttype,
    windowlong: this.windowlong,
    windowwide: this.windowwide
    });
  }
  
     presentModalGriffe(griffe_subcat) {
     if (griffe_subcat == 0) {
     this.selectedGriffe = "keine Griffe";
     this.griffe_img = "../../assets/imgs/placeholder.png";
     } else {
    let griffeModal = this.modalCtrl.create(GriffeTypPage, {
      'selectedGriffe': this.choosenGriffe,
       griffe_subcat: griffe_subcat,
    });
    griffeModal.onDidDismiss(data => {
      this.selectedGriffe = data.griffe;
      this.griffe_img = data.griffe_img;
    });
    griffeModal.present();
  }
  }
   

}



// WEBPACK FOOTER //
// ./src/pages/griffe/griffe.ts